<script setup lang="ts">
import { computed } from 'vue'
import { IconWifi } from '@xpos/icons-svg'
const props = withDefaults(defineProps<{ mbps: number, latency: number }>(), { mbps: 50, latency: 0 })
// 1: <15Mbps OR >=150ms | 2: >=15Mbps AND <150ms | 3: >=50Mbps AND <50ms
const level = computed(() => (props.mbps < 15 || props.latency >= 150) ? 1 : (props.mbps < 50 || props.latency >= 50) ? 2 : 3)
const color = computed(() => level.value === 3 ? '#80BA5C' : level.value === 2 ? '#F5A623' : '#E53030')
</script>
<template>
  <IconWifi :style="{ color }" />
</template>
